<app-dialog-header (backClick)="onNoClick()" [header]="ordedLicenseDetails.dealerRemoteMaintenanceOrder.id"></app-dialog-header>

<div class="dialog-view-wrapper">  

    <h2 class="panel-title">{{ 'Modules.Licenses.List.OrderHistory.OrderDetails.OrderInfo' | translate }}</h2>
    <div class="details-card">
      <div>
        <h4 class="detail-type">{{ 'Modules.Licenses.List.OrderHistory.OrderDetails.Id' | translate }}</h4>
        <div class="detail-value">{{ ordedLicenseDetails.dealerRemoteMaintenanceOrder.id }}</div>
      </div>

      <div>
        <h4 class="detail-type">{{ 'Modules.Licenses.List.OrderHistory.OrderDetails.CompanyName' | translate }}</h4>
        <div class="detail-value">{{ getCompanyName() }}</div>
      </div>

      <div>
        <h4 class="detail-type">{{ 'Modules.Licenses.List.OrderHistory.OrderDetails.CreatedUtc' | translate }}</h4>
        <div class="detail-value">{{ ordedLicenseDetails.dealerRemoteMaintenanceOrder.createdUtc | localizedDate: 'short' }}</div>
      </div>

      <div>
        <h4 class="detail-type">{{ 'Modules.Licenses.List.OrderHistory.OrderDetails.CreatedByUserEmail' | translate }}</h4>
        <div class="detail-value">{{ ordedLicenseDetails.annotatedOrder.createdByUser.email }}</div>
      </div>
    </div>
  

    <table *ngIf="newLicenses.length > 0" mat-table [dataSource]="newLicenses" class="order-overview-table">
      <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef>{{ 'Modules.Licenses.Orders.Table.StoreNewLicense' | translate }}</th>
        <td mat-cell *matCellDef="let license">
          <div class="license-title">{{ getStoreName(license) }}</div>
          <div class="license-sub-title">{{ getStoreInfoString(license) }}</div>
        </td>
      </ng-container>
    
      <tr mat-header-row *matHeaderRowDef="displayedColumnsNewLicenses"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsNewLicenses;"></tr>
    </table>

    <table *ngIf="cancelledLicenses.length > 0" mat-table [dataSource]="cancelledLicenses" class="order-overview-table">
      <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef>{{ 'Modules.Licenses.Orders.Table.StoreCancelledLicense' | translate }}</th>
        <td mat-cell *matCellDef="let license">          
          <div class="license-title">{{ getStoreName(license) }}</div>
          <div class="license-sub-title">{{ getStoreInfoString(license) }}</div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumnsCancelledLicenses"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsCancelledLicenses;"></tr>
    </table>
</div>